// course_info can hold several rows with the same course name. Dropdowns should
// list each name once: keep the first option and remember every id that shares
// its name in `ids`, so existing records (which may point at any of those ids)
// still resolve to the single visible option.
export function dedupeCourseOptions(options, getLabel = (option) => option.label) {
    const byName = new Map();
    (options || []).forEach((option) => {
        const key = String(getLabel(option) ?? '').trim().toLowerCase();
        const id = String(option.value);
        if (!key) {
            byName.set(`id:${id}`, { ...option, ids: [id] });
            return;
        }
        const existing = byName.get(key);
        if (existing) {
            if (!existing.ids.includes(id)) existing.ids.push(id);
        } else {
            byName.set(key, { ...option, ids: [id] });
        }
    });
    return Array.from(byName.values());
}

export const optionHasId = (option, id) =>
    (option?.ids ?? [String(option?.value)]).includes(String(id));
